import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Download, FileText } from "lucide-react";
import { Link } from "react-router-dom";

async function downloadDoc(docId, filename) {
  const { data } = await api.get(`/documents/${docId}/download`, { responseType: "blob" });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url; a.download = filename || "document"; a.click();
  URL.revokeObjectURL(url);
}

export default function Documents() {
  const { data: docs = [] } = useQuery({ queryKey: ["all-docs"], queryFn: async () => (await api.get("/documents")).data });
  return (
    <div>
      <h1 className="font-display text-3xl font-bold tracking-tight text-[#06152D]">Documents</h1>
      <p className="text-sm text-[#52525B]">Every KYC / loan / insurance document across your customers. Upload from a customer's profile.</p>

      <div className="mt-6 bg-white border border-[#E4E4E7] rounded-xl overflow-hidden">
        <table className="w-full lj-table" data-testid="documents-table">
          <thead><tr><th></th><th>Type</th><th>Filename</th><th>Customer</th><th>Size</th><th>Uploaded</th><th></th></tr></thead>
          <tbody>
            {docs.length === 0 && <tr><td colSpan="7" className="text-center text-[#52525B] py-8">No documents yet.</td></tr>}
            {docs.map((d) => (
              <tr key={d.id}>
                <td><FileText size={16} className="text-[#0052FF]" /></td>
                <td className="text-xs font-semibold uppercase tracking-wider text-[#52525B]">{d.doc_type}</td>
                <td>{d.original_filename}</td>
                <td><Link to={`/admin/customers/${d.customer_id}`} className="text-xs text-[#0052FF] hover:underline">Open customer</Link></td>
                <td className="text-xs text-[#52525B]">{(d.size / 1024).toFixed(1)} KB</td>
                <td className="text-xs text-[#52525B]">{new Date(d.uploaded_at).toLocaleDateString("en-IN")}</td>
                <td>
                  <button onClick={() => downloadDoc(d.id, d.original_filename)} className="text-[#0052FF] hover:text-[#003FCC] inline-flex items-center gap-1 text-xs font-semibold" data-testid={`docs-download-${d.id}`}>
                    <Download size={12} /> Download
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
